import { AsyncActionStatus } from "../../shared/abstractStore";
import { useAsyncCallback } from "react-use-async-callback";
import { useAccountService } from "./useAccountService";

/**
 * Callback to resend the inviten email.
 */
export function useResendInviteEmailCallback(): [(email: string) => Promise<boolean>, AsyncActionStatus] {
    const accountService = useAccountService();

    const [action, { isExecuting, errors }] = useAsyncCallback(async (email: string) => {
        return await accountService.resendInviteEmail(email);
    }, [accountService]);

    return [action, { isExecuting, errors }];
}
